module.exports = __webpack_public_path__ + "static/media/file.3b678d1e.svg";